import { Trans } from "@lingui/macro";
import Link from "next/link";
import React from "react";

import { Navbar } from "./Navbar";
import NotFoundSeo from "./seo/NotFoundSeo";

export interface Custom404Props {
	withNavbar?: boolean;
}

const Custom404: React.VFC<Custom404Props> = ({ withNavbar = false }) => {
	return (
		<>
			<NotFoundSeo />
			<div className="min-h-screen bg-gray-100">
				{withNavbar && <Navbar />}

				<div className="py-10">
					<header className="mb-4">
						<div className="max-w-7xl mx-auto px-8">
							<Trans>Page not found</Trans>
						</div>
					</header>
					<main>
						<div className="max-w-7xl mx-auto px-8">
							<Link href="/">
								<a>
									<Trans>Go back home</Trans>
								</a>
							</Link>
						</div>
					</main>
				</div>
			</div>
		</>
	);
};

export default Custom404;
